var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scrollBox", {
    attrs: {
      data: _vm.data,
      loading: _vm.loading,
      total: _vm.total,
      showMore: _vm.showMore
    },
    on: {
      loadMore: function($event) {
        return _vm.$emit("loadMore")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "left",
        fn: function(scope) {
          return [
            _c("file-record", {
              attrs: {
                title: _vm.fileName(scope.row.fileUrl),
                url: scope.row.fileUrl,
                size: scope.row.fileSize || "未知",
                fileType: scope.row.fileExt,
                type: "left"
              }
            })
          ]
        }
      },
      {
        key: "right",
        fn: function(scope) {
          return [
            _c("file-record", {
              attrs: {
                title: _vm.fileName(scope.row.fileUrl),
                url: scope.row.fileUrl,
                size: scope.row.fileSize || "未知",
                fileType: scope.row.fileExt,
                type: "right"
              }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }